const services = [
  {
    slug: 'webontwikkeling',
    titleKey: 'web_development',
    contentKey: 'web_development_content'
  },
  {
    slug: 'software-app-ontwikkeling',
    titleKey: 'software_app_development',
    contentKey: 'software_app_development_content'
  },
  {
    slug: 'design-branding',
    titleKey: 'design_branding',
    contentKey: 'design_branding_content'
  },
  {
    slug: 'marketing-advertenties',
    titleKey: 'marketing_advertising',
    contentKey: 'marketing_advertising_content'
  },
  {
    slug: 'consulting-strategie',
    titleKey: 'consulting_strategy',
    contentKey: 'consulting_strategy_content'
  }
];

const getServiceBySlug = (slug) => services.find((s) => s.slug === slug);

const serviceDetails = {
  'webontwikkeling': {
    titleKey: 'web_development',
    contentKey: 'web_development_detail_content',
    image: '/asset/img/web-development.jpg',
  },
  'software-app-ontwikkeling': {
    titleKey: 'software_app_development',
    contentKey: 'software_app_development_detail_content',
    image: '/asset/img/software-development.jpg',
  },
  'design-branding': {
    titleKey: 'design_branding',
    contentKey: 'design_branding_detail_content',
    image: '/asset/img/design-branding.jpg',
  },
  'marketing-advertenties': {
    titleKey: 'marketing_advertising',
    contentKey: 'marketing_advertising_detail_content',
    image: '/asset/img/marketing-advertising.jpg',
  },
  'consulting-strategie': {
    titleKey: 'consulting_strategy',
    contentKey: 'consulting_strategy_detail_content',
    image: '/asset/img/consulting-strategy.jpg',
  },
};

module.exports = { services, getServiceBySlug, serviceDetails };
